import * as cmmn from '@utils/index';
import {environment} from "@env";
import {logger} from "@services/logger/logger.service";
import {IQuickAction} from "@core/base/chat-setting-base";
import { coreCrypto } from "@core/r2";
import { BaseHost } from "@core/shared/office-hosts/base-host";
import { IOfficeHost } from "@core/shared/office-hosts/office-host.types";
import { DOCUMENT_UID_KEY } from "@core/shared/office-hosts/office-hosts-constants";

export class PowerPointHost extends BaseHost implements IOfficeHost
{
    public override async getDocumentIDAsync(): Promise<string> {
        let documentID = Office.context.document.settings.get(DOCUMENT_UID_KEY)

        if (!documentID) {
            documentID = coreCrypto.uuidV4();
            Office.context.document.settings.set(DOCUMENT_UID_KEY, documentID);

            const isSaved = await cmmn.callAsync<boolean>(async (r) => {
                Office.context.document.settings.saveAsync((saveResult: Office.AsyncResult<void>) => {
                    if (saveResult.status == Office.AsyncResultStatus.Failed) {
                        logger.error(`error code: ${saveResult.error.code}, name: ${saveResult.error.name}, message: '${saveResult.error.message}'`);
                        r.next(false);
                    } else {
                        r.next(true);
                    }
                });
            });

            if (!isSaved) {
                documentID = undefined;
            }
        }

        return documentID;
    }

    public override checkSelectable() { return true; }
    public override checkEditable(): boolean { return true; }
    public override checkDocumentReadable(): boolean {return false;}

    public override getQuickActions(): IQuickAction[] {
        return environment.quick_actions.PowerPoint;
    }

    public override async getSelectedContentAsync(): Promise<string> {
        let resultStr = '';

        const resultValue = await cmmn.callAsync<boolean>(async (r) => {
            Office.context.document.getSelectedDataAsync<string>(Office.CoercionType.Text, (getResult) => {
                if (getResult.status == Office.AsyncResultStatus.Failed) {
                    logger.error("error: " + getResult.error.name + ", " + getResult.error.message);
                    return r.next(false);
                }

                resultStr = getResult.value;
                return r.next(true);
            });
        });

        if (resultValue) {
            return resultStr;
        }

        return '';
    }

    public override async setSelectedTextAsync(plainText:string): Promise<void> {
        Office.context.document.setSelectedDataAsync(
            plainText,
            {
                coercionType: Office.CoercionType.Text
            },
        );
    }
}
